import React, { useEffect } from "react";
import {
  Pagination,
  PaginationItem,
  SvgIcon,
  SvgIconProps,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import {
  DARK_GREY,
  GREY,
  PRIMARY_BLUE,
} from "@trane/trane-components/dist/color";
import {
  SPACING_04,
  SPACING_02,
  SPACING_06,
} from "@trane/trane-components/dist/spacing";
import { Block } from "@trane/trane-components/dist";
import styled from "styled-components";

import {
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

export interface CustomPaginationProps {
  setPageSize: Function;
}

export const PaginationIcon = styled.figure`
  cursor: pointer;
  margin: 0 0 0 ${SPACING_04};
`;

export function FirstIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M5.9995,5 L5.9995,11.998 L7.4145,10.586 L12.3635,5.636 L13.7785,7.05 L9.8285,11 L20.0005,11 L20.0005,13 L9.8285,13 L13.7785,16.95 L12.3635,18.364 L7.4145,13.414 L5.9995,12 L5.9995,19 L3.9995,19 L3.9995,5 L5.9995,5 Z"
        id="path-1"
      />
    </SvgIcon>
  );
}

export function NextIcon(props) {
  return (
    <SvgIcon {...props}>
      <polygon
        width="24px"
        height="24px"
        id="path-1"
        fill="#1E1E1E"
        transform="translate(12.000500, 12.000000) rotate(-180.000000) translate(-12.000500, -12.000000) "
        points="11.364 5.636 12.779 7.05 8.829 11 19.001 11 19.001 13 8.829 13 12.779 16.95 11.364 18.364 6.415 13.414 5 12 6.415 10.586"
      ></polygon>
    </SvgIcon>
  );
}

export function BackIcon(props) {
  return (
    <SvgIcon {...props}>
      <polygon
        id="path-1"
        points="11.364 5.636 12.779 7.05 8.829 11 19.001 11 19.001 13 8.829 13 12.779 16.95 11.364 18.364 6.415 13.414 5 12 6.415 10.586"
      ></polygon>
    </SvgIcon>
  );
}

export function LastIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M11.6365,18.364 L10.2215,16.95 L14.1715,13 L3.9995,13 L3.9995,11 L14.1715,11 L10.2215,7.05 L11.6365,5.636 L16.5855,10.586 L18.0005,12 L16.5855,13.414 L11.6365,18.364 Z M20.0005,19 L18.0005,19 L18.0005,5 L20.0005,5 Z"
        id="path-1"
      />
    </SvgIcon>
  );
}

export const CustomPagination = (props) => {
  const viewPage = [30, 60, 90];
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const [paginationCount, setPaginationCount] = React.useState(30);
  
  useEffect(() => {
    apiRef.current.setPageSize(paginationCount);
  }, [])
  
  const setPageSizeInstance = (pageSize) => {
    console.log(pageSize)
    apiRef.current.setPageSize(pageSize);
  }

  const handleFirstPageButtonClick = (event,value) => {
    apiRef.current.setPage(value - 1);
    const sElement = document.getElementById("mgmDashTop");
    if (sElement !== null)
      sElement.scrollIntoView();
  }

  return (
    <Block
      display="flex"
      justify="space-between"
      flexDirection="row"
      align="center"
    >
      <Block width="auto" display="flex" flexDirection="row" padding="10px 0 0 0">
        <Typography
          variant="body1"
          sx={{ fontFamily: "arial", fontWeight: "700", color: DARK_GREY }}
        >
          View
        </Typography>

        {viewPage.map((item, idx) => {
          return (
            <Typography
              variant="body1"
              key={`Table-Pagination-Option-${item}-${idx}`}
              onClick={() => {
                setPaginationCount(item);
                setPageSizeInstance(item)
              }}
              sx={{
                color: `${paginationCount === item ? PRIMARY_BLUE : GREY}`,
                margin: `0 ${SPACING_02}`,
                padding: "0 2px 6px 2px",
                cursor: "pointer",
                textDecoration: `${paginationCount === item ? "underline" : "none"}`,
                
                weight: `${paginationCount === item ? "700" : "100"}`,
              }}
            >
              {item}
            </Typography>
          );
        })}
      </Block>
      <Block width="auto" display="flex">
        {/* <Typography
          variant="body1"
          sx={{ fontFamily: "arial", fontWeight: "700", color: DARK_GREY, padding: "10px 10px 0 0" }}
        >
          Page {page + 1} of {pageCount}
        </Typography> */}
        <Pagination
          sx={{ padding: "0 0 0 10px" }}
          color="primary"
          count={pageCount}
          showFirstButton
          showLastButton
          siblingCount={1}
          boundaryCount={1}
          renderItem={(item) => (
            <PaginationItem
              components={{
                previous: BackIcon,
                next: NextIcon,
                last: LastIcon,
                first: FirstIcon,
              }}
              {...item}
            />
          )}
          onChange={(event, value) => {
            handleFirstPageButtonClick(event, value);
          }}
        />
      </Block>
    </Block>
  );
};

export default CustomPagination;
